import type { SelectProps } from '@mui/material';
import { FormControl, FormHelperText, InputLabel, Select } from '@mui/material';
import type { FormikProps } from 'formik';
import type { ReactNode } from 'react';

type Props<ID, T> = SelectProps & {
  id: ID;
  error?: boolean;
  formik: FormikProps<T>;
  helperText?: ReactNode;
  label: ReactNode;
};

export function FormikSelect<
  ID extends string,
  T extends { [key in ID]?: string | number },
>(props: Props<ID, T>): JSX.Element {
  const { formik, label, ...selectProps } = props;
  return (
    <FormControl
      disabled={formik.isSubmitting || props.disabled}
      error={
        (formik.touched[props.id] && Boolean(formik.errors[props.id])) ||
        props.error
      }
      fullWidth
    >
      <InputLabel id={`${props.id}-select-label`}>{label}</InputLabel>
      <Select
        {...selectProps}
        disabled={formik.isSubmitting || props.disabled}
        label={label}
        labelId={`${props.id}-select-label`}
        name={props.name ?? props.id}
        onBlur={formik.handleBlur}
        onChange={formik.handleChange}
        value={formik.values[props.id]}
      />
      {(formik.touched[props.id] && Boolean(formik.errors[props.id])) ||
        (props.helperText && (
          <FormHelperText>
            {(formik.errors[props.id] as string) || props.helperText}
          </FormHelperText>
        ))}
    </FormControl>
  );
}
